import { showLabel } from '@/utils/helper';
import { OnoffType } from '@/api/enum/common.enum';
import { Chip } from '@mui/material';

interface Props {
	published: boolean | number | string | undefined;
	publishList: { id: OnoffType; name: string }[];
}

export default function PublishedChip({ published, publishList }: Props) {
	return (
		<Chip
			color={published == OnoffType.on ? 'chipPrimary' : 'default'}
			label={showLabel(published, publishList)}
		/>
	);
}
